module.exports = __webpack_public_path__ + "20c7c0918ce53df503803056d37b6440.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-76.cur
// module id = 476
// module chunks = 0